const UsersTableColumns = [
    { id: 'avatar', labelAr: 'الصورة', labelEn: 'Avatar', width: 80 },
    { id: 'name', labelAr: 'الاسم', labelEn: 'Name' },
    { id: 'user_name', labelAr: 'اسم المستخدم', labelEn: 'Username' },
    { id: 'email', labelAr: 'البريد الإلكتروني', labelEn: 'Email' },
    { id: 'phone', labelAr: 'الهاتف', labelEn: 'Phone' },
    { id: 'is_active', labelAr: 'الحالة', labelEn: 'Status', width: 120 },
    { id: 'roles', labelAr: 'الأدوار', labelEn: 'Roles' },
];

export default UsersTableColumns;
